export const Messages = {
  RequiredSalesOriginValidationMessage: '^Informe a Origem de Venda.',
  RequiredSaveSharepointValidationMessage: '^Informe o Upload Sharepoint..',
  RequiredJustificationSharepointValidationMessage: '^Descreva o Motivo de não salvar no Sharepoint..',
  RequiredMainVehicleValidationMessage: '^Informe o Veiculo.',
  RequiredEmailValidationMessage: '^Informe o seu e-mail.',
  RequiredClientValidationMessage: '^Informe o Cliente.',
  RequiredAgencyValidationMessage: '^Informe a Agência.',
  RequiredCommercialPlanValidationMessage: '^Informe o Plano Comercial.',
  RequiredSalesTypeValidationMessage: '^Informe o Tipo de Venda.',
  RequiredNatureValidationMessage: '^Informe a Natureza.',
  RequiredDiscountValidationMessage: '^Informe o Desconto.',
  RequiredComprehensivenessValidationMessage: '^Informe as Abrangências.',
  RequiredBeginDateValidationMessage: '^Informe a Data de Início.',
  RequiredEndDateValidationMessage: '^Informe a Data de Fim.',
  RequiredTableValidationMessage: '^Informe a Tabela.',
  RequiredPaymentTypeValidationMessage: '^Informe a Forma de Pagamento.',
  RequiredAmountValidationMessage: '^Informe o Valor.',
  RequiredPercentValidationMessage: '^Informe a Porcentagem.',
  RequiredVehicleValidationMessage: '^Selecione o Veículo.',
  RequiredPasswordValidationMessage: '^Informe sua senha de acesso.',
  NegotiationSuccessSave: 'Pré-venda salva com sucesso!',
  CommercialPlanWithoutResults: 'Nenhum Plano Comercial foi encontrado.',
  NegotiationApportionmentRequired: 'Nenhum Rateio informado.',
  NegotiationApportionmentInvalid:
    'O valor total do rateio precisa ser inferior ao valor total da Pré-venda.',
  NegotiationApportionmentExceed:
    'Valor informado é maior do que o disponível.',
  MailingInDevelopment: 'Funcionalidade em desenvolvimento.',
  UserIsNotExecutive:
    'Cadastro não permitido. É necessário possuir perfil de Executivo Comercial.',
  RequiredTotalAmountForRegiterRateioMessage:
    'Informe o Valor Total da Pré-venda antes de cadastrar os Rateios.',
  NegotiationApportionmentNotRegister: 'Clique em Incluir antes de Finalizar.'
};
